import { getCall, listCall, postCall, putCall, delCall } from "./commonApi";

export async function getOrgGroupUsers(orgId) {
  let res = await listCall("/list/users?orgId=" + orgId);
  return res;
}

export async function getUsers(orgId) {
  let res = await listCall("/list/orgUsersList/" + orgId);
  return res;
}

export async function getLoggedUserData(id) {
  let res = await getCall("/general/getLoggedUserData/" + id);
  return res;
}

export async function validateVerificationCode(id, code) {
  let res = await getCall(
    "/general/validateVerificationCode/" + id + "/" + code
  );
  return res;
}

export async function getUserOrgs(userId) {
  let res = await listCall("/list/userOrgsList/" + userId);
  return res;
}

export async function createUser(data) {
  let res = await postCall("/general/create/addUser", data);
  return res;
}

export async function enableMFA(data) {
  let res = await postCall("/general/create/enableMFA", data);
  return res;
}

export async function updateUser(userId, data) {
  let res = await putCall("/general/update/users/" + userId, data);
  return res;
}
export async function updateAddress(userId, data) {
  let res = await putCall("/general/update/userProfile/" + userId, data);
  return res;
}

export async function changeUsername(oldId, newId) {
  let res = await putCall(
    "/general/changeUserMobileNumber/" + oldId + "/" + newId,
    {}
  );
  return res;
}

export async function updateUserStatus(userId, data) {
  let res = await putCall("/general/updateUserStatus/" + userId, data);
  return res;
}

export async function removeProfile(profileId) {
  let res = await delCall("/general/delete/deleteProfile/" + profileId);
  return res;
}

export async function removeUser(userId) {
  let res = await delCall("/general/delete/deleteUser/" + userId);
  return res;
}

export async function updateCaregiverUser(userId, data) {
  let res = await putCall("/general/updateCaregiverStatus/" + userId, data);
  return res;
}

export async function signupFirstResponder(data) {
  let res = await postCall("/noAuth/signup", data, true);
  return res;
}

export async function signupForUserAndProfile(data) {
  let res = await postCall("/noAuth/specialNeedsRegistration", data, true);
  return res;
}

export async function getProfileAnalytics(userId, profileId, orgId) {
  let res = await getCall(
    "/general/getUserAnalytics/" + userId + "/" + profileId + "/" + orgId
  );
  return res;
}
